import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { ChartDataItem } from "../../utils/chart-values";

interface WomacTableProps {
	chartData: ChartDataItem[];
}

function roundTo1DP(value: number): string {
	return value.toFixed(1);
}

function formatPercentage(value: number, max: number): string {
	return `${((value / max) * 100).toFixed(1)}%`;
}

export function WomacTable({ chartData }: WomacTableProps) {
	// Filter out data points with no entries
	const filteredData = chartData.filter((point) => point.entries_count > 0);

	return (
		<Table>
			<TableHeader>
				<TableRow>
					<TableHead>Time Point</TableHead>
					<TableHead className="text-right">Pain Score</TableHead>
					<TableHead className="text-right">Stiffness Score</TableHead>
					<TableHead className="text-right">Function Score</TableHead>
					<TableHead className="text-right">Total Score</TableHead>
					<TableHead className="text-right">Entries</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{filteredData.map((data) => {
					const painScore = Number(data["WOMAC Pain Score"]) || 0;
					const stiffnessScore = Number(data["WOMAC Stiffness Score"]) || 0;
					const functionScore = Number(data["WOMAC Function Score"]) || 0;
					const totalScore = painScore + stiffnessScore + functionScore;

					return (
						<TableRow key={data.timing}>
							<TableCell className="font-medium">{data.timing}</TableCell>
							<TableCell className="text-right">
								{data["WOMAC Pain Score"] !== undefined ? (
									<div className="flex flex-col items-end">
										<span>{roundTo1DP(painScore)}/20</span>
										<span className="text-muted-foreground text-xs">
											{formatPercentage(painScore, 20)}
										</span>
									</div>
								) : (
									"-"
								)}
							</TableCell>
							<TableCell className="text-right">
								{data["WOMAC Stiffness Score"] !== undefined ? (
									<div className="flex flex-col items-end">
										<span>{roundTo1DP(stiffnessScore)}/8</span>
										<span className="text-muted-foreground text-xs">
											{formatPercentage(stiffnessScore, 8)}
										</span>
									</div>
								) : (
									"-"
								)}
							</TableCell>
							<TableCell className="text-right">
								{data["WOMAC Function Score"] !== undefined ? (
									<div className="flex flex-col items-end">
										<span>{roundTo1DP(functionScore)}/68</span>
										<span className="text-muted-foreground text-xs">
											{formatPercentage(functionScore, 68)}
										</span>
									</div>
								) : (
									"-"
								)}
							</TableCell>
							<TableCell className="text-right">
								<div className="flex flex-col items-end">
									<span>{roundTo1DP(totalScore)}/96</span>
									<span className="text-muted-foreground text-xs">
										{formatPercentage(totalScore, 96)}
									</span>
								</div>
							</TableCell>
							<TableCell className="text-right">{data.entries_count}</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</Table>
	);
}
